import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({ name: 'renderMentions' })
export class MentionPipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) {}

    transform(text: string, lang: string): SafeHtml {
        if (!text) return '';

        const escaped = text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

        const rendered = escaped.replace(/@\[([^\]:]+):([^\]]+)\]/g, (_, id, name) => {
            if (name === '__deleted__') {
                const label = lang === 'fr' ? 'Utilisateur supprimé' : 'Deleted user';
                return `<span class="mention mention--deleted">@${label}</span>`;
            }
            return `<span class="mention" data-user-id="${id}" role="button" tabindex="0">@${name}</span>`;
        });

        return this.sanitizer.bypassSecurityTrustHtml(rendered);
    }
}
